import React from "react";
import { bankAccountsOf } from "../utils/moneySources";

// "Paid from" (bank accounts and credit cards) or, with `accountsOnly`, "Received into"
// (bank accounts). The value is "account:<id>" / "card:<id>", or "" for none. When
// `required`, there is no "Don't track" choice, just a prompt to pick one. Used by the
// phone and desktop forms alike; `style` is the form's own input style.
const MoneySourceSelect = ({ value, onChange, assets = [], cards = [], accountsOnly = false, required = false, style, id }) => {
  const accounts = bankAccountsOf(assets);
  return (
    <select id={id} style={style} value={value} onChange={(e) => onChange(e.target.value)}>
      {required ? <option value="" disabled>Select</option> : <option value="">Don't track</option>}
      {accounts.length > 0 && (
        <optgroup label="Bank accounts">
          {accounts.map((a) => <option key={`a${a.id}`} value={`account:${a.id}`}>{a.name}{a.last4 ? ` ••${a.last4}` : ""}</option>)}
        </optgroup>
      )}
      {!accountsOnly && cards.length > 0 && (
        <optgroup label="Credit cards">
          {cards.map((c) => <option key={`c${c.id}`} value={`card:${c.id}`}>{c.name}{c.last4 ? ` ••${c.last4}` : ""}</option>)}
        </optgroup>
      )}
    </select>
  );
};

export default MoneySourceSelect;
